import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { Banner } from '@famly/mf_data-display_banner';
import { kinderConnectCaptureSettingsErrorStateE2eId } from './kinder-connect-capture-settings-e2e-ids';
/**
 * Shown in place of the children list when it fails to load.
 */
export const KinderConnectCaptureSettingsChildrenListError = () => (_jsx(Banner, { severity: "error", text: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings.loadError), "data-e2e-id": kinderConnectCaptureSettingsErrorStateE2eId }));
